import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router'
import Loading from '../../components/Loading'
import { Parser } from 'html-to-react'
import { store } from '../../components/HOC/State'
import { translate } from '../translate'
import { axiosInstance } from '../../const/axiosInstance'
import styles from './job.module.css'

export default function JobPage() {
    const [el, setEl] = useState({})
    const [loading, setLoading] = useState(false)

    const  {selectedLang} = useContext(store)
    let lang = translate[selectedLang]

    const htmlParser = new Parser()
  
    const {id} = useParams()

 
    useEffect(() =>{
        (async() => {
            setLoading(true)
            const res = await axiosInstance.get(`/use/career/${id}`)
            if(res.data.status){
              setEl(res.data.data)
            }else{
                setEl({})
            }
            setLoading(false)
        })()
      }, [])
    
  return (
        <div className={styles['job-page-main']}>
            {loading ? <Loading width={200}/> : 
            <div className={styles['job-page-info']}>
                <p className={styles['job-category']}>{lang.tr_work}</p>
                <h2 className={styles['job-page-title']}>{el[`${selectedLang}name`]}</h2>
                <div className="material">
                    {htmlParser.parse(el[`${selectedLang}information`]?.
                            replaceAll(`iframe width="auto" height="auto"`, `iframe width="${0.6*window.innerWidth}" height="${0.6*window.innerWidth/1.6}" allowfullscreen`).
                            replaceAll("alt=\"undefined\" style=\"height: auto;width: auto\"/>", `alt="undefined" "height="auto" width="${0.6*window.innerWidth}"/>`))}    
                </div>
            </div>}
      </div>
  )
}
